import { useState, useEffect } from "react";
import { RATING_TIMER_DURATION } from "../constants/searchPageConstants";

export const useRatingTimer = (signInTime, count) => {
    const [timeElapsed, setTimeElapsed] = useState(false);

    useEffect(() => {
        if (!signInTime || count >= 3) return;

        const timeRemaining = RATING_TIMER_DURATION - (Date.now() - signInTime);

        // If 3 minutes already passed, set immediately
        if (timeRemaining <= 0) {
            setTimeElapsed(true);
            return;
        }

        // Otherwise, set a timer
        const timer = setTimeout(() => {
            setTimeElapsed(true);
        }, timeRemaining);

        return () => clearTimeout(timer);
    }, [signInTime, count]);

    return timeElapsed;
};
